import { createSlice } from "@reduxjs/toolkit";
import { config } from "../utils/Constants";

const initialState = {
  request: {
    activeRowIndex: -1,
    visible: false,
    TransactionID: null,
    method: null,
  },

  response: {
    transferDetails: {},
    loading: true,
  },
  error: null,
};

const transferDetails = createSlice({
  name: "transferDetails",
  initialState,
  reducers: {
    settingData: (state, action) => {
      const { field, value } = action.payload;
      state[field] = value;
    },
    setTransferAbroadRequestData: (state, action) => {
      const { field, value } = action.payload;
      state.request[field] = value;
    },
    setResponseAbroadData: (state, action) => {
      const { field, value } = action.payload;
      state.response[field] = value;
    },
    resetRequest: (state) => {
      state.request = initialState.request;
    },
    resetResponse: (state) => {
      state.response = initialState.response;
      state.request = initialState.request;

    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  settingData,
  setTransferAbroadRequestData,
  setResponseAbroadData,
  resetRequest,
  resetResponse,
  setError,
} = transferDetails.actions;

export default transferDetails.reducer;
